import "./TwoLeftOneRightLayoutComponent.scss";
import template from "./TwoLeftOneRightLayoutComponent.html";
import {IComponentOptions} from "angular";
import {Observable} from "rxjs";
import {WidgetDisplayMode} from "../../../models/WidgetDisplayMode";
import {BreakpointObserver} from "../../../../../services/breakpoints/BreakpointObserver";
import {Breakpoint} from "../../../../../services/breakpoints/Breakpoint";

export const TwoLeftOneRight = "tfTwoLeftOneRightLayout";

export function twoLeftOneRight(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: TwoLeftOneRightLayoutController
    };
}

export class TwoLeftOneRightLayoutController {

    public readonly leftWidgetsDisplay$: Observable<WidgetDisplayMode>;
    public readonly rightWidgetDisplay$: Observable<WidgetDisplayMode>;

    /** @ngInject */
    public constructor(private readonly breakpointObserver: BreakpointObserver) {
        this.leftWidgetsDisplay$ = this.buildWidgetDisplay();
        this.rightWidgetDisplay$ = this.buildWidgetDisplay();
    }

    private buildWidgetDisplay(): Observable<WidgetDisplayMode> {
        return this.breakpointObserver
                   .observe(Breakpoint.WebLandscape)
                   .map((bp) => bp.active)
                   .map((active) => active ? WidgetDisplayMode.WIDE : WidgetDisplayMode.TALL)
                   .publishReplay(1)
                   .refCount();
    }
}
